import * as React from 'react';

import {Body} from '../../typography/body';

import styles from './account-card-contents.module.css';

type Props = {
    description: string | null | undefined;
    location: string | null | undefined;
    phoneNumber?: string | null | undefined;
    phoneExtension?: string | null | undefined;
    connectButtonsRow?: React.ReactNode;
};

export function AccountCardContents(props: Props) {
    return (
        <div className='flex flex-dir-col gap-2'>
            {props.description && (
                <div className={styles['description-container']}>
                    <Body size='small' as='div' wrapAnywhere={true} title={props.description}>
                        {props.description}
                    </Body>
                </div>
            )}
            {props.phoneNumber && (
                <Body size='small' as='div'>
                    {props.phoneNumber} {props.phoneExtension && `ext. ${props.phoneExtension}`}
                </Body>
            )}
            <Body size='small' as='div' color='placeholder' wrapAnywhere={true}>
                {props.location ? props.location : 'No location'}
            </Body>
            {props.connectButtonsRow}
        </div>
    );
}
